export const TooltipHoverEnterDelayMs = 2000;
export const TooltipHoverLeaveDelayMs = 120;
